<script>
import posed from "vue-pose";

export default {
    data() {
        return {
            busy: false,
            selectedIndex: -1,
        };
    },

    props: {
        heading: {
            type: String,
        },
        description: {
            type: String,
        },
        content: {
            type: Array,
        },
    },

    computed: {

        
    },

    watch: {},

    methods: {
        didSelectIndex: function (index) {
            this.selectedIndex = this.selectedIndex === index ? -1 : index;
        },
        filterList: function(event){
            this.type = event.target.value;
        }, 
    },

    components: {
        Body: posed.div({
            open: {
                opacity: 1,
                height: "auto",
            },
            closed: {
                opacity: 1,
                height: 0,
                transition: { duration: 300 },
            },
        }),
    },

    created() {},

    destroyed() {},

    mounted() {},
};
</script>

<style></style>

<template>

    <div class="accordion-content">
        
        <div class="accordion-content__header">
            <h5 v-if="heading" class="accordion-content__heading category-title">
                {{ heading }}
            </h5>

            <p
                v-if="description && description.length"
                class="accordion-content__description"
                v-html="description"
            ></p>
        </div>

        <article
            v-for="(item, index) in content"
            :key="index + '-' + index"
            class="accordion-content__item"
            :class="{ 'accordion-content__item--open': selectedIndex == index }"
        >
            <div class="accordion-content__item__header">
                <h2 class="accordion-content__item__header__title">{{ item.title }}</h2>
                 <div class="accordion-content__item__header__category">
                    <span v-for="term in item.pillars" :key="term.slug">{{ term.title }}</span>
                 </div>
                <button v-on:click.prevent="didSelectIndex(index)">
                    <span class="sr-only">Read More</span>
                </button>
            </div>

            <Body
                class="accordion-content__item__body"
                :pose="selectedIndex == index ? 'open' : 'closed'"
            >
                <div class="accordion-content__item__body__inner">
                    <div class="accordion-content__item__body__content">
                        <div v-html="item.content"></div>
                        <div v-html="item.services_snippet"></div>
                        <div
                            v-if="item.button_url"
                            class="accordion-content__item__body__content__footer"
                        >
                            <a class="button" :href="item.button_url">{{
                                item.button_label
                            }}</a>
                        </div>
                    </div>
                </div>
            </Body>
        </article>
    </div>
</template>
